module.exports = __webpack_public_path__ + "img/red_006.8a8da23c.png";